<template>
  <div class="external-main-temp">
    <div :class="bindExternalUidClass">
      <div class="lt">
        <input
          ref="uid-input"
          v-model="uidValue"
          @input="handleInput(1)"
          :placeholder="placeholderText"
          @blur="handleBlur"
          @keyup.enter="handleBlur"
          :style="bindInputStyle"
        />
      </div>
      <div class="rt">
        <input
          ref="zid-input"
          v-model="serverId"
          @input="handleInput(2)"
          @blur="handleBlur"
          @keyup.enter="handleBlur"
          :placeholder="zoneIdPlaceholder"
          :style="bindInputStyle"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { storage } from '@/utils/storage'
  import { chineseReg } from '@/utils/regExp'
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { hexToRgba } from '@/utils/hexToRgba'

  export default {
    mixins: [styleConfiguration],
    data() {
      return {
        initLoad: true,
        isEventSelect: false,
        serverId: '', // serverid
        uidValue: '', //UID
        cacheSkuState: [], //缓存选中每个SKU的状态
        validator: {
          isInInput: false, // 是否在输入中
          isError: false, // 验证错误uid
          isZidError: false, // 验证错误zid
          isSuccess: false, // 验证成功
          isLoading: false, // 验证中
        },
        errorCode: 0,
      }
    },
    components: {},
    watch: {},
    mounted() {
      this.getCacheUid()
    },
    destroyed() {},
    computed: {
      ...mapState(['gameName', 'isDesktop', 'isMobile', 'region', 'isIAP']),
      ...mapState('detail', ['selectChannelItem']),
      ...mapGetters('detail', ['cacheUidKey', 'cacheZidKey']),
      ...mapGetters(['isOnmyojiArena', 'isCpMd', 'isAllExternalGames']),
      bindInputStyle() {
        return {
          backgroundColor: this.skuBackColor.backgroundColor,
          borderColor: this.skuBackColor.borderColor,
          color: this.mFontColor.color,
          '--placeholderColor': hexToRgba(this.mFontColor.color),
        }
      },
      bindExternalUidClass() {
        const defaultClass = ['external-uid-content']
        let device = []

        if (this.isDesktop) {
          device.push(`${defaultClass[0]}-desktop`)
        }
        if (this.isMobile) {
          device.push(`${defaultClass[0]}-mobile`)
        }
        return defaultClass.concat(device)
      },

      placeholderText() {
        if (this.gameName === 'lr') {
          return this.$t(`publicDetails.uid_placeholder`, {
            uid: 'Player ID',
          })
        }
        return this.$t(`publicDetails.uid_placeholder`, {
          uid: 'UID',
        })
      },
      zoneIdPlaceholder() {
        if (this.gameName === 'lr' || this.gameName === 'mu-a') {
          return 'Server ID'
        }
        if (this.isOnmyojiArena) {
          return 'Charactername'
        }
        if (this.isCpMd) {
          return 'Username'
        }
        const key = `${this.gameName}.zoneid_placeholder`
        const zidMsg = this.$te(key)
          ? this.$t(key)
          : this.$t('publicDetails.zoneid_placeholder')

        if (this.isMobile) {
          return `(    ${zidMsg}    )`
        }
        return `${zidMsg}`
      },
      successIcon() {
        return require('@/assets/images/detail/common/success.png')
      },
    },

    methods: {
      ...mapMutations(['detail/setUserId', 'detail/setServerId']),

      getCacheUid() {
        const { uid, serid } = this.handleCache('get')
        if (!(uid && serid)) return

        this.uidValue = uid
        this.serverId = serid

        this['detail/setUserId'](this.uidValue)
        this['detail/setServerId'](this.serverId)
      },

      handleCache(type = 'get', { uid = '', serid = '' } = {}) {
        if (type === 'get') {
          const uid = storage.get(this.cacheUidKey) || null
          const serid = storage.get(this.cacheZidKey) || null
          return {
            uid,
            serid,
          }
        }
        if (type === 'set') {
          storage.set(this.cacheUidKey, uid)
          storage.set(this.cacheZidKey, serid)
        }
      },
      handleBlur() {
        if (this.uidValue && this.serverId) {
          this.handleCache('set', {
            uid: this.uidValue,
            serid: this.serverId,
          })
        }
        this['detail/setUserId'](this.uidValue)
        this['detail/setServerId'](this.serverId)
      },
      handleInput(type = 1) {
        if (this.isAllExternalGames) {
          if (type === 1) {
            this.uidValue = this.uidValue.replace(chineseReg, '')
          } else if (type === 2) {
            this.serverId = this.serverId.replace(chineseReg, '')
          }
        }
        // this.uidValue = this.uidValue.replace(/\D/g, '')
        // this.serverId = this.serverId.replace(/\D/g, '')
      },
    },
  }
</script>
<style scoped lang="scss" src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
  @media (min-width: 768px) and (max-width: 1280px) {
    @import './styles_pc.scss';
  }
  @media (max-width: 900px) {
    @import './900.scss';
  }
</style>
